import request from '@/utils/request'

let Vehicle_modelApi = {

  /*车型列表*/
  list(data) {
    return request._post('/shop/plus.vehicle_model.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.vehicle_model.Index/indexx', data);
},
/*添加车型*/
add(data) {
    return request._post('/shop/plus.vehicle_model.Index/add', data);
},
/*修改车型*/
edit(data) {
    return request._post('/shop/plus.vehicle_model.Index/edit', data);
},
/*删除车型*/
del(data) {
    return request._post('/shop/plus.vehicle_model.Index/del', data);
},
/*车型详情*/
detail(data) {
  return request._post('/shop/plus.vehicle_model.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.vehicle_model.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.vehicle_model.Setting/getSetting', data, errorback);
    },
}
export default Vehicle_modelApi;



// WEBPACK FOOTER //
// ./src/api/vehicle_model.js